export default __webpack_public_path__ + "static/media/sg.6cc62188.svg";